import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SearchPanel from "@widgets/SearchPanel";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  modalRef?: any;
}

const SN_MAS_ORG_REG_002_POP_05 = forwardRef(
  ({ modalRef }: popupProps, ref) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any[]>([]);
    const [dataSource, setDataSource] = useState<any[]>([]);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [gridApiRefH.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_MAS_ORG_REG_002_POP_05", {});
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(rtn.formData); // 조회조건 초기값
          setColums(rtn.grid.grid1); // H그리드 항목 설정
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    const onSearch = async () => {
      try {
        const params = {
          id: "sn_mas_org_reg_002_pop_01_05",
          params: searchRef.current.getFormdata(),
        };

        setDataSource([]);
        const data: any = await fnGetDataSet(params);
        setDataSource(data[0]);

        if (data[0] && data[0].length > 0) {
          // 1. 그리드 데이터가 바인딩되었음을 기다림
          await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

          // 2. 첫 번째 행 선택 및 포커스 설정
          gridApiRefH.current.selectAndFocusRow(0);
        }

        gridApiRefH.current.resetUpdate();
      } catch (error) {}
    };
    //#endregion

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div style={{ display: "flex", gap: "10px", flex: 1 }}>
          <div style={{ flex: 1, marginTop: "10px" }}>
            <SnGrid
              seq={1}
              ref={gridApiRefH} // Grid Name
              columnConfig={columns} // 컬럼 설정 전달
              rowData={dataSource} // DataSource
              rowSelection="single" // 행 선택 모드(단일)
              isEditable={false} // 수정 가능 여부
              enableAddRow={false} // 행 추가 여부
              ischeckboxSelection={false} // 체크박스 유무
              cellSelection={false}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MAS_ORG_REG_002_POP_05;
